import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { useAuth } from '../context/auth';
import isUserLoadingState from '../state/common/atoms/isUserLoadingState';
import userState from '../state/common/atoms/userState';
import useCheckRedirect from './useCheckRedirect';
import useUserService from './useUserService';

const useCheckLogin = () => {
    const { get: getUserData } = useUserService();
    const userData = useRecoilValue(userState);
    const setIsLoading = useSetRecoilState(isUserLoadingState);
    const { isLoggedIn, login, logout, setUserAndToken } = useAuth();
    useCheckRedirect();

    useEffect(() => {
        // StrictMode will mount and then immediately unmount this component
        // Do not run then of promise if request was cancelled due to strict mode
        let isCancelled = false;

        // if we haven't tried to login or we have just logged in and not yet requested the user data
        if (
            isLoggedIn === null ||
            (isLoggedIn === true && userData === false)
        ) {
            setIsLoading(true);
            getUserData()
                .then((response) => {
                    if (isCancelled) {
                        return;
                    }

                    if (response) {
                        setUserAndToken(response.user);
                        login();
                    } else {
                        logout();
                    }

                    setIsLoading(false);
                })
                .catch(() => {
                    logout();
                    setIsLoading(false);
                });
        }

        return () => {
            isCancelled = true;
        };
    }, [isLoggedIn]);
};

export default useCheckLogin;
